<template>
	<v-dialog
		v-model="dialog"
		max-width="500"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn class="mx-4" v-bind="attrs" v-on="on" color="secondary">
				<v-icon class="mr-1">mdi-check-circle-outline</v-icon>
				検査結果入力
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 検査結果入力</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark color="white" @click="dialog = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-4 font-weight-bold text-h6">
				<p>工程名：{{ checkProcessName }}</p>
			</div>
			<v-form ref="form" v-model="valid" class="pa-2">
				<v-text-field
					type="number"
					class="px-4 append-outer"
					:hint="permit_quantity > quantity ? '許可数量が検査数量を超えています' : ''"
					label="許可数量"
					v-model="permit_quantity"
					:rules="[rules.required, rules.moreThanZero]"
					hide-spin-buttons
					outlined
					dense
				>
					<template v-slot:append>
						<v-btn icon class="mb-1 plus-minus-btn" @click="incrementQuantity"
							><v-icon>mdi-plus-circle-outline</v-icon></v-btn
						>
						<v-btn icon class="mb-1 plus-minus-btn" @click="decrementQuantity"
							><v-icon>mdi-minus-circle-outline</v-icon></v-btn
						>
					</template>
				</v-text-field>
			</v-form>

			<v-card-actions>
				<v-row no-gutters class="mt-4 pb-2">
					<v-col sm="3" cols="0" />
					<v-col sm="6" cols="12" class="text-center">
						<v-btn color="secondary" @click="accept" :disabled="!valid || disabledBtn()">
							<v-icon class="mr-1">mdi-check</v-icon>
							上記で許可する
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import rules from "../../../helper/rules"
export default {
	props: {
		checkProcessName: {
			type: String,
			required: true,
		},
		quantity: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			dialog: false,
			permit_quantity: null,
			rules,
			valid: false,
		}
	},
	methods: {
		accept() {
			this.$emit("accept", this.permit_quantity)
			this.dialog = false
		},

		incrementQuantity() {
			this.permit_quantity++
		},

		decrementQuantity() {
			if (this.permit_quantity == 0 || this.permit_quantity == null) return
			this.permit_quantity--
		},
		disabledBtn() {
			return (
				this.permit_quantity == null ||
				this.permit_quantity <= 0 ||
				this.permit_quantity > this.quantity
			)
		},
	},
	watch: {
		dialog(value) {
			if (value) {
				this.permit_quantity = this.quantity
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.plus-minus-btn {
	height: 30px;
}
</style>
